import type { FC } from 'react';
import { useEmployeeCards } from '@pflegenavi/frontend/api-nursing-home';
import { EmployeeCardsMenuView } from './EmployeeCardsMenuView';

export const EmployeeCardsMenu: FC = () => {
  const { data } = useEmployeeCards();

  // Most employees have no card, so the icon only shows for cardholders.
  if (!data || data.data.length === 0) {
    return null;
  }

  return <EmployeeCardsMenuView cards={data.data} />;
};
